// extracted by mini-css-extract-plugin
module.exports = {"networkIcon":"networkIcon__3HhPq","tile":"tile__2cTbP","details":"details__3U0IO","info":"info__3gr7C","title":"title__26VSx","titlespan":"titlespan__3wco3"};